import React from 'react'
import { PARAM_PHONE_NUMBER } from '../constants/params'
import { parseFromLocalStorage } from '../helper/localStorage'
import { exitViettelMoneyApp, getViettelMoneyUserInfo, SDK_RESULT_STATUS, SDK_SOURCE } from './ViettelMoney'

export { SDK_RESULT_STATUS, SDK_SOURCE }

export const useSdk = () => {
  const getPhoneNumberFromUrl = React.useCallback(() => {
    const phoneNumber = new URLSearchParams(window.location.search).get(PARAM_PHONE_NUMBER) || undefined

    if (!phoneNumber) {
      return undefined
    }

    return {
      phoneNumber
    }
  }, [])

  const getUserInfoBySdk = React.useCallback(
    async (payload) => {
      if (parseFromLocalStorage(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)) {
        const viettelMoneyResult = await getViettelMoneyUserInfo(payload)

        if (viettelMoneyResult?.status !== SDK_RESULT_STATUS.NO_ATTEMPT) {
          return viettelMoneyResult
        }
      }

      const phoneFromUrl = getPhoneNumberFromUrl()

      if (phoneFromUrl) {
        return {
          status: SDK_RESULT_STATUS.SUCCESS,
          source: SDK_SOURCE.URL_PARAMS,
          data: phoneFromUrl
        }
      }

      return {
        status: SDK_RESULT_STATUS.NO_ATTEMPT,
        source: SDK_SOURCE.URL_PARAMS
      }
    },
    [getPhoneNumberFromUrl]
  )

  const exitAppBySdk = React.useCallback(async (payload) => {
    if (parseFromLocalStorage(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)) {
      return exitViettelMoneyApp(payload)
    }
  }, [])

  return {
    getUserInfoBySdk,
    exitAppBySdk
  }
}
